package pwgs.ui.scenes.playererrorsscene

import kotlinx.serialization.Serializable
import visage.rmi.VisageController

@VisageController(PlayerErrorsSceneProps::class, PlayerErrorsSceneModel::class)
interface PlayerErrors {

    fun load()

}

@Serializable
data class PlayerErrorsSceneProps(
    val projectId: Long,
    val userId: String
)

@Serializable
class PlayerErrorsSceneModel(
    val issues: List<DiagnosticsIssueModel>
) {
    var isLoading = true
}

@Serializable
class DiagnosticsIssueModel(
    val id: Long,
    val userId: String,
    val userName: String,
    val message: String,
    val createdAt: Long,
    val version: String,
    val device: String,
    val stackTrace: String,
    val breadCrumbs: List<DiagnosticsBreadCrumbModel>
)

@Serializable
class DiagnosticsBreadCrumbModel(
    val type: String,
    val message: String,
    val tMinus: Long
)
